module.exports = __webpack_public_path__ + "media/images/area/feature/chubu/banner/zh-hant-7a79b8c62f6564da6ebec58079993cb1.jpg";